module.exports = __webpack_public_path__ + "static/img/icon_src.44b9f4b9.svg";